import { LanguageCodes } from '../index';
import { DEFAULT_LANGUAGE } from '../context';
import {
	LanguageCode,
	TranslationObject,
	TranslationVariables
} from '../types/translation.types';

export let language = {} as TranslationObject;

const substituteVariables = (
	text: string,
	variables: TranslationVariables = {}
): string => {
	return text.replace(/\{\{(.*?)\}\}/g, (_, varName) => {
		const trimmedVarName = varName.trim();
		return String(variables[trimmedVarName] ?? '');
	});
};

const getNestedValue = (
	obj: TranslationObject,
	keyPath: string
): string | null => {
	const keys = keyPath.split('.');
	let current: TranslationObject | string = obj;

	for (const key of keys) {
		if (!current || typeof current !== 'object' || !(key in current)) {
			return null;
		}
		current = current[key];
	}

	return typeof current === 'string' ? current : null;
};

export const getTranslation = (
	languagePack: TranslationObject,
	currentLanguage?: LanguageCode
) => {
	// Cache the language pack globally
	language = languagePack;

	return (key: string, variables: TranslationVariables = {}): string => {
		// Try to get translation from current language
		const translation = getNestedValue(languagePack, key);

		if (translation) {
			return substituteVariables(translation, variables);
		}

		// Fallback to default language if key not found
		const fallbackTranslation = getNestedValue(
			LanguageCodes[DEFAULT_LANGUAGE],
			key
		);

		if (fallbackTranslation) {
			if (currentLanguage && currentLanguage !== DEFAULT_LANGUAGE) {
				console.warn(
					`Translation key "${key}" not found for language "${currentLanguage}", using ${DEFAULT_LANGUAGE} fallback`
				);
			}
			return substituteVariables(fallbackTranslation, variables);
		}

		// Final fallback: return the key itself
		console.warn(
			`Translation key "${key}" not found for language "${
				currentLanguage || 'unknown'
			}"`
		);
		return key;
	};
};
